var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { createElement } from 'react';
import { CoreAdminUI } from 'ra-core';
import { ScopedCssBaseline } from '@mui/material';
import { Layout as DefaultLayout, LoadingPage, NotFound, Notification, } from './layout';
import { Login, AuthCallback } from './auth';
export var AdminUI = function (_a) {
    var _b = _a.layout, layout = _b === void 0 ? DefaultLayout : _b, _c = _a.catchAll, catchAll = _c === void 0 ? NotFound : _c, _d = _a.loading, loading = _d === void 0 ? LoadingPage : _d, _e = _a.loginPage, loginPage = _e === void 0 ? Login : _e, _f = _a.authCallbackPage, authCallbackPage = _f === void 0 ? AuthCallback : _f, _g = _a.notification, notification = _g === void 0 ? Notification : _g, props = __rest(_a, ["layout", "catchAll", "loading", "loginPage", "authCallbackPage", "notification"]);
    return (React.createElement(ScopedCssBaseline, { enableColorScheme: true },
        React.createElement(CoreAdminUI, __assign({ layout: layout, catchAll: catchAll, loading: loading, loginPage: loginPage, authCallbackPage: authCallbackPage }, props)),
        createElement(notification)));
};
//# sourceMappingURL=AdminUI.js.map